import { format } from "date-fns";

export function getFilename(reportName: string) {
  const currentDate = new Date();

  return reportName + format(currentDate, "-MM-dd-yyyy-HH-mm-ss-aa");
}
